const {
    REACT_APP_GOOGLE_MAP_API_KEY,
    REACT_APP_GOOGLE_MAP_LIBEARIES
} = process.env;

export default {
    BASE_URL: "https://maps.googleapis.com/maps/api/place/autocomplete/json",
    API_KEY: REACT_APP_GOOGLE_MAP_API_KEY,
    LIBRARIES_MAPS: REACT_APP_GOOGLE_MAP_LIBEARIES ? JSON.parse(REACT_APP_GOOGLE_MAP_LIBEARIES) : []
}